import React, { useState, useEffect, useRef } from "react";

import rddApi from "apis/rdd";
import { PageLoader, SubHeader } from "clearsense-ui/components";

import PatientDetailsForm from "./Form";
import PredictionResult from "./PredictionResult";
// import SearchSectionInput from "./SearchSectionInput";

/*
 * Lines commented out since features are yet to be implemented.
 */

const RenalDiseaseDetection = () => {
  // const [patientId, setPatientId] = useState("");
  const [patientData] = useState({
    name: "",
    dateOfBirth: "",
  });
  const [prediction, setPrediction] = useState();
  const [isLoading] = useState(false);
  // const [selectedRadioOption, setSelectedRadioOption] = useState(
  //   PATIENT_ID_IS_CHECKED
  // );

  const resultRef = useRef(null);

  useEffect(() => {
    prediction && resultRef.current.scrollIntoView({ behavior: "smooth" });
  }, [prediction]);

  // useEffect(() => {
  //   const clearInputs = () => {
  //     if (selectedRadioOption === PATIENT_NAME_IS_CHECKED) {
  //       setPatientId("");
  //     }

  //     if (selectedRadioOption === PATIENT_ID_IS_CHECKED) {
  //       setPatientData({
  //         name: "",
  //         dateOfBirth: "",
  //       });
  //     }
  //   };
  //   clearInputs();
  // }, [selectedRadioOption]);

  // const handlePatientIdChange = e => {
  //   setPatientId(e.target.value);
  // };

  // const handleRadioOptionChange = e => {
  //   setSelectedRadioOption(e.target.value);
  // };

  // const handlePatientDataChange = (name, value) => {
  //   setPatientData({ ...patientData, [name]: value });
  // };

  // const handleDateChange = (_, dateString) => {
  //   setPatientData({ ...patientData, dateOfBirth: dateString });
  // };

  const handleSubmit = async payload => {
    try {
      const { data } = await rddApi.predict(payload);
      const prediction = data.ckd_risk;
      const value = isNaN(parseFloat(prediction))
        ? 0
        : parseFloat(prediction).toFixed(2);
      setPrediction(value);
    } catch (error) {
      logger.log(error);
    }
  };

  if (isLoading) {
    return <PageLoader loading={isLoading} />;
  }

  return (
    <div className="cs-ui-container cs-ui-container__table cs-rdd-page">
      <SubHeader
        className="mt-8"
        breadcrumbs={[
          {
            label: "Renal Disease Detection",
            link: "/consumption/data-science/predictive-analysis/rdd",
          },
          {
            label: "Overview",
            link: "#",
          },
        ]}
      />
      <div className="flex gap-10">
        <div className="flex flex-col justify-start gap-10 mt-10">
          {/* <div className="pb-10 space-y-5 border-b-2">
            <Typography style="h3" type="semibold" className="text-gray-600">
              Search for Patient
            </Typography>
            <div className="flex flex-col">
              <SearchSectionInput
                title={SEARCH_INPUT_FIELDS[0].title}
                value={patientId}
                onValueChange={handlePatientIdChange}
                placeholder="Enter Patient ID"
                radioValue={PATIENT_ID_IS_CHECKED}
                checked={selectedRadioOption === PATIENT_ID_IS_CHECKED}
                disabled={selectedRadioOption === PATIENT_NAME_IS_CHECKED}
                handleRadioChange={handleRadioOptionChange}
                tooltipContent={SEARCH_INPUT_FIELDS[0].tooltipContent}
              />
              <SearchSectionInput
                title={SEARCH_INPUT_FIELDS[1].title}
                value={patientData}
                name={patientData}
                isMultiValued
                onValueChange={e =>
                  handlePatientDataChange("name", e.target.value)
                }
                onDateChange={handleDateChange}
                placeholder="Enter Patient Name"
                radioValue={PATIENT_NAME_IS_CHECKED}
                checked={selectedRadioOption === PATIENT_NAME_IS_CHECKED}
                disabled={selectedRadioOption === PATIENT_ID_IS_CHECKED}
                handleRadioChange={handleRadioOptionChange}
                isDatePicker
                tooltipContent={SEARCH_INPUT_FIELDS[1].tooltipContent}
              />
            </div>
          </div> */}
          <PatientDetailsForm
            patientData={patientData}
            handleSubmit={handleSubmit}
            prediction={prediction}
            setPrediction={setPrediction}
          />
        </div>
        {!!prediction && (
          <PredictionResult
            prediction={prediction}
            setPrediction={setPrediction}
            ref={resultRef}
          />
        )}
      </div>
    </div>
  );
};

export default RenalDiseaseDetection;
